<template>
  <el-form-item ref="patientSurname" prop="patientSurname">
    <el-input
      v-on="$listeners"
      v-bind="$attrs"
      :value="value"
      placeholder="Apellidos"
    />
  </el-form-item>
</template>

<script>
export default {
  props: {
    value: {
      required: false
    }
  }
}
</script>
